import { combineReducers } from 'redux';

import accounts from './account';
import auth from './auth'

export default combineReducers({ accounts, auth });